export default {
  about: "Acerca de",
  aboutUs: "Sobre Nosotros",
  contact: "Contacto",
  careers: "Carreras",
  legal: "Legal",
  privacy: "Política de Privacidad",
  terms: "Términos de Servicio",
  cookies: "Política de Cookies",
  social: "Social",
  language: "Idioma",
  rights: "Todos los derechos reservados.",
  changed: "Idioma cambiado",
  changedDescription: "El idioma ha sido cambiado exitosamente"
};